export const GET_USERS = "GET_USERS";

export const GetUsersProps = () => {
    return { type: GET_USERS };
};
